export default "__VITE_ASSET__wAOF_DLh__"